import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRe010 {
  // GET parameters
  export namespace Get {
    export interface Request {
      query: {
        memberStudyDiagnosisReportsId: number
      }
    }

    // API Response
    export interface Response {
      learningReport: {
        memNum: string
        grade: number
        fiscalYear: number
        reportMonth: string
        message1: string
        message2: string
        subjectReportArray: {
          subjectId: string
          name: string
          subjectComments: string
          subjectPoint: number
          finishedPieceNum: number
          totalPieceNum: number
        }[]
      }
    }
  }

  // API Path
  const path: string = '/ta/learningReport'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        learningReport: {
          memNum: '',
          grade: 0,
          fiscalYear: 0,
          reportMonth: '',
          message1: '',
          message2: '',
          subjectReportArray: [
            {
              subjectId: '',
              name: '',
              subjectComments: '',
              subjectPoint: 0,
              finishedPieceNum: 0,
              totalPieceNum: 0,
            },
          ],
        },
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
